import React, { Component } from 'react';
import Helmet from 'react-helmet';
import PersonIcon from 'material-design-icons/action/svg/production/ic_perm_identity_48px.svg';

import SignUpForm from '../../components/SignUpForm';
import SheetTitle from '../../components/SheetTitle';
import { smoothScroll } from '../../helpers/view';

import c from './Signup.less';

class SignupContainer extends Component {
  componentDidMount() {
    smoothScroll();
  }

  render() {
    return (
      <div className={c.container}>
        <Helmet defer={false}>
          <title>Sign Up at Mp3Caprice</title>
          <meta property="mc:dp" content="/shop/signup" />
          <meta property="mc:page" content="Signup" />
        </Helmet>
        <SheetTitle title="Sign up" />
        <div className={c.wrapper}>
          <SignUpForm />
        </div>
        <div className={c.personIcon}><PersonIcon /></div>
      </div>
    );
  }
}

export default SignupContainer;
